<template>
  <popup :opened="show" @close="$emit('close')">
    <div
      class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto flex flex-col items-center space-y-10"
    >
      <h3>Ajouter un nouveau lien d'affiliation</h3>
      <input-text
        name="structure_name"
        libelle=""
        placeholder="Nom de la structure affiliée"
        :value="name"
        @input="
          (newValue) => {
            name = newValue;
          }
        "
      />
      <action-button
        bg-color="bg-pink-600"
        border-color="border-pink-600"
        :disabled="false"
        icon="arrow-right_1"
        icon-color="text-white"
        libelle="Créer"
        text-color="text-white"
        :right="true"
        :uppercase="true"
        :spinner="loading"
        @clickAction="addNewAffiliate()"
      />
    </div>
  </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import ActionButton from '../../../components/ActionButton.vue';

export default {
  components: {
    Popup,
    InputText,
    ActionButton,
  },

  props: {
    show: Boolean,
    loading: Boolean,
  },

  data() {
    return {
      name: '',
    };
  },

  methods: {
    async addNewAffiliate() {
      await this.$emit('newAffiliate', this.name);

      this.name = '';
    },
  },
};
</script>
